export const documentsPages = {
  documents: () => import('./pages/DocumentsPage'),
};
